export enum ActionTypes {
  AUTH_LOGIN = 'AUTH_LOGIN',
  AUTH_LOGOUT = 'AUTH_LOGOUT',
  USER_REQUEST = 'USER_REQUEST',
  STORE_ROUTES = 'STORE_ROUTES',
  STORE_FAVORITE_COURSES = 'STORE_FAVORITE_COURSES'
}
